import React, { useState, useEffect } from "react";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const GetInTouchSection = () => {
    const variant="outlined";
    const url = "https://www.sigmatiqa.com"; //"http://localhost:3600"; 

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        organisation: "",
        message: "",
        agree: false,
        csrfToken: "",
        honeypot: ""
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errors, setErrors] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false); // Track submission state

    const buttonSx = {
        height: '48px', 
        backgroundColor: '#333333',
        width: "100%",
        ...(success && {
          bgcolor: "#00ad31",
          '&:hover': {
            bgcolor: "#018527",
          },
        })
      };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors([]); // Clear previous errors
        setIsSubmitting(true); // Darken the background

        const response = await fetch(url + "/api/v1/submit-form", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
        });

        setIsSubmitting(false);

        setLoading(false);

        if (response.ok) {
            alert("Your enquiry has been sent successfully!");
            setFormData({
                name: "",
                email: "",
                message: "",
                agree: false,
                csrfToken: formData.csrfToken, // Keep the CSRF token
                honeypot: "", // Reset honeypot field
            });
        } else {
            const errorData = await response.json();
            if (errorData.errors)
            {
                setErrors(errorData.errors);
            }
            else
            {
                alert("Failed to send your enquiry. Please try again later.");
            }
        }
    };

    return (
        <Container>
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0',
                backgroundColor: '#f5f5f5',
                marginBottom: 3
                //borderBottom: '1px solid #ddd',
            }}
        >
            
            <Stack
                component="form"
                sx={{ width: '50ch', marginTop: '20px', marginBottom: '20px' }}
                spacing={4}
                noValidate
                autoComplete="off"
            >
                <Typography 
                    variant="h4" 
                    sx={{ 
                        fontSize: 36, 
                        fontWeight: 600, // semi-bold
                        color: '#111111', 
                        marginBottom: 1,
                        textAlign: 'center'
                    }}
                >
                    Get in touch
                </Typography>
                <Typography 
                    variant="h6" 
                    sx={{ 
                        fontSize: 14, 
                        fontWeight: 400, // semi-bold
                        color: '#4d4d4d', 
                        marginBottom: 1,
                        textAlign: 'center'
                    }}
                >
                    Contact us for more information about our products and services
                </Typography>
                    <TextField 
                        id="outlined-basic" 
                        label="Full name" 
                        error=""
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        variant="outlined" 
                        fullWidth 
                        required
                        slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                    <AccountCircle />
                                </InputAdornment>
                              ),
                            }
                        }}
                    />
                    <TextField 
                        id="outlined-basic" 
                        label="Organisation" 
                        error=""
                        variant="outlined" 
                        name="organisation"
                        value={formData.organisation}
                        onChange={handleChange}
                        fullWidth 
                        slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                    <BusinessOutlinedIcon />
                                </InputAdornment>
                              ),
                            }
                        }}
                    />
                    <TextField 
                        id="outlined-basic" 
                        label="Email" 
                        error=""
                        variant="outlined" 
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth 
                        required
                        slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                    <EmailOutlinedIcon />
                                </InputAdornment>
                              ),
                            }
                        }}
                    />
                    <TextField 
                        id="outlined-basic" 
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        label="Message" 
                        variant="outlined" 
                        fullWidth required multiline maxRows={4} rows={4}/>
                    <FormControlLabel 
                        required 
                        control={
                            <Checkbox
                              name="agree"
                              checked={formData.agree}
                              onChange={handleChange}
                            />
                        }
                        label="Accept privacy policy" />
                    <Box sx={{ m: 1, position: 'relative', width: "100%" }}>
                        <Button 
                            variant="contained" 
                            sx={buttonSx}
                            disabled={!formData.agree || loading}
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                        {loading && (
                            <CircularProgress
                                size={24}
                                sx={{
                                color: "#00ad31",
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                marginTop: '-12px',
                                marginLeft: '-12px',
                                }}
                            />
                        )}
                    </Box>
            </Stack>
            
        </Box>
        </Container>
    );
};

export default GetInTouchSection;